export default "__VITE_ASSET__B6G49ogk__"